import { TCategory, TTopCategory } from '../data';

export const getPopularCategoriesData = (
	topCategories: TTopCategory[],
	popularCategoriesIds: number[]
) => {
	const data = [] as TCategory[];
	popularCategoriesIds.forEach(searchId => {
		topCategories.forEach(({ categories }) => {
			data.push(...categories.filter(({ categoryId }) => searchId === categoryId));
		});
	});
	return data;
};
